import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return localStorage.getItem("ilakeit_lang") || "it";
  });

  useEffect(() => {
    localStorage.setItem("ilakeit_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const parts = key.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else { cur = null; break; }
    }
    if (cur != null) return cur;
    // fallback to IT
    let it = translations.it;
    for (const p of parts) {
      if (it && typeof it === "object" && p in it) it = it[p];
      else { it = null; break; }
    }
    return it ?? key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
